export default {"src":"/_next/static/media/top.f5dc2b1c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};